export const SPENDS_AND_OPPORTUNITIES__WEEKLY_SEASONALITY =
  'spends_and_opportunities__weekly_seasonality';
export const SPENDS_AND_OPPORTUNITIES__WEEKLY_SEASONALITY_LOCAL =
  'spends_and_opportunities__weekly_seasonality_local';
export const SPENDS_AND_OPPORTUNITIES__MONTHLY_SEASONALITY =
  'spends_and_opportunities__monthly_seasonality';
export const SPENDS_AND_OPPORTUNITIES__MONTHLY_SEASONALITY_LOCAL =
  'spends_and_opportunities__monthly_seasonality_local';
export const SPENDS_AND_OPPORTUNITIES__WEEKLY_PERCENTAGE_TO_PLAN_OVERTIME =
  'spends_and_opportunities__weekly_percentage_to_plan_overtime';
export const SPENDS_AND_OPPORTUNITIES__WEEKLY_PERCENTAGE_TO_PLAN_OVERTIME_LOCAL =
  'spends_and_opportunities__weekly_percentage_to_plan_overtime_local';
export const SPENDS_AND_OPPORTUNITIES__MONTHLY_PERCENTAGE_TO_PLAN_OVERTIME =
  'spends_and_opportunities__monthly_percentage_to_plan_overtime';
export const SPENDS_AND_OPPORTUNITIES__MONTHLY_PERCENTAGE_TO_PLAN_OVERTIME_LOCAL =
  'spends_and_opportunities__monthly_percentage_to_plan_overtime_local';
export const SPENDS_AND_OPPORTUNITIES__WEEKLY_OVERTIME =
  'spends_and_opportunities__weekly_overtime';
export const SPENDS_AND_OPPORTUNITIES__WEEKLY_OVERTIME_LOCAL =
  'spends_and_opportunities__weekly_overtime_local';
export const SPENDS_AND_OPPORTUNITIES__MONTHLY_OVERTIME =
  'spends_and_opportunities__monthly_overtime';
export const SPENDS_AND_OPPORTUNITIES__MONTHLY_OVERTIME_LOCAL =
  'spends_and_opportunities__monthly_overtime_local';

// Initial Plan Spend constants
export const INITIAL_PLAN_SPEND__OVERTIME_WEEKLY = 'initial_plan_spend__overtime_weekly';
export const INITIAL_PLAN_SPEND__OVERTIME_MONTHLY = 'initial_plan_spend__overtime_monthly';

// Initial Plan Opportunities constants
export const INITIAL_PLAN_OPPORTUNITIES__OVERTIME_WEEKLY =
  'initial_plan_opportunities__overtime_weekly';
export const INITIAL_PLAN_OPPORTUNITIES__OVERTIME_MONTHLY =
  'initial_plan_opportunities__overtime_monthly';

export const SPEND_AND_OPPS_FILE_NAME_WEEKLY = 'spend_and_opportunities_weekly.xlsx';
export const SPEND_AND_OPPS_FILE_NAME_LOCAL_SPEND_WEEKLY =
  'spend_and_opportunities_local_spend_weekly.xlsx';
export const SPEND_AND_OPPS_FILE_NAME_MONTHLY = 'spend_and_opportunities_monthly.xlsx';
export const SPEND_AND_OPPS_FILE_NAME_LOCAL_SPEND_MONTHLY =
  'spend_and_opportunities_local_spend_monthly.xlsx';

export const OPPS_DATA = 'opps_data';
export const SPENDS_DATA = 'spends_data';
export const WEEKLY = 'Weekly';
export const MONTHLY = 'Monthly';
export const fiscalMonths = {
  1: 'Dec',
  2: 'Jan',
  3: 'Feb',
  4: 'Mar',
  5: 'Apr',
  6: 'May',
  7: 'Jun',
  8: 'Jul',
  9: 'Aug',
  10: 'Sep',
  11: 'Oct',
  12: 'Nov',
};

export const MONTHLY_OPPS_SEASONALITY = 'Monthly_Opps_Seasonality';
export const MONTHLY_SPENDS_SEASONALITY = 'Monthly_Spends_Seasonality';
export const WEEKLY_OPPS_SEASONALITY = 'Weekly_Opps_Seasonality';
export const WEEKLY_SPENDS_SEASONALITY = 'Weekly_Spends_Seasonality';
export const WEEK_AVG = '(6-weeks Avg)';
export const WEEK_AVG_TOGGLE_TEXT = '6-weeks Avg';
export const LEGENDS_HIGHLIGHT_TEXT = '(Click above legends to show/hide values on graph)';
export const ACTUAL_SPEND_KEY = 'Actual Spend';
export const PLANNED_SPEND_KEY = 'Planned Spend';
export const ACTUAL_OPPS_KEY = 'Actual Opps';
export const PLANNED_OPPS_KEY = 'Planned Opps';
export const DEFAULT_LOCAL_SPEND_TOGGLE_YEAR = 2024;
